const PopupType = {
	VESSEL: "vessel",
	HISTORIC: "historic",
	HEATMAP_POINT: "heatmap-point",
	CUSTOM: "custom",
	CUSTOM_HTML: "custom-html"
};
export default PopupType;
